import CompanySettingView from "@/views/company/settings/CompanySettingView";

export default [
  {
    name: "pages.company.settings",
    path: "settings",
    component: CompanySettingView
  },
  
  
];
